import { render } from "./PaginateModule.vue?vue&type=template&id=7bbd9e91"
import script from "./PaginateModule.vue?vue&type=script&lang=js"
export * from "./PaginateModule.vue?vue&type=script&lang=js"

import "./PaginateModule.vue?vue&type=style&index=0&id=7bbd9e91&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__